import { DateTime } from 'luxon'
import type { MissionButtonReminder } from '../../components/MissionButton/RemindersButton/types'

type Input = {
  reminders: MissionButtonReminder[]
  currentDateTime: DateTime
  endDateTime: DateTime
}

export type GetRemindersWithOccasionsResult = {
  remindersWithOccasions: MissionButtonReminder[]
  hasRemindersWithOccasions: boolean
}

export const getRemindersWithOccasions = ({
  reminders,
  currentDateTime,
  endDateTime,
}: Input): GetRemindersWithOccasionsResult => {
  const remindersWithOccasions = reminders
    .filter(reminder => {
      const reminderDate = DateTime.fromISO(reminder.nextDate)
      return reminderDate > currentDateTime && reminderDate < endDateTime
    })
    .sort((previousReminder, currentReminder) =>
      previousReminder.nextDate.localeCompare(currentReminder.nextDate),
    )

  return {
    remindersWithOccasions,
    hasRemindersWithOccasions: remindersWithOccasions.length > 0,
  }
}
